module.exports = __webpack_public_path__ + "files/8204f1c1b86ac280be982e2f7d5f0348.mp3";